
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import {
  PermissionCode, BoxStatusType,
} from '@/types';
import {
  currentUserHasPermission,
} from '@/helpers';

@Component
export default class CheckZonaVincolo extends Vue {
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;
  @Prop({ type: String, required: true }) readonly checkZonaVincolo!: BoxStatusType | null;
  @Prop({ type: String, required: true }) readonly autodichiarazioneCliente!: BoxStatusType | null;

  hasPermission(codename: PermissionCode): boolean { return currentUserHasPermission(codename); }

  boxText(boxStatus: BoxStatusType): string {
    switch (boxStatus) {
      case 'todo':
        return 'Da fare';

      case 'done':
        return 'Fatto';

      case 'waiting':
        return 'In attesa';

      case 'na':
        return 'Non applicabile';

      default:
        break;
    }

    return 'Non disponibile';
  }

  boxColor(boxStatus: BoxStatusType): string {
    switch (boxStatus) {
      case 'na':
      case 'todo':
        return 'grey';

      case 'done':
        return 'success';

      case 'waiting':
        return 'orange';

      default:
        break;
    }

    return '';
  }

  boxDark(boxStatus: BoxStatusType): boolean {
    switch (boxStatus) {
      case 'todo':
      case 'done':
      case 'waiting':
        return true;

      case 'na':
        return false;

      default:
        break;
    }

    return true;
  }

  boxOutlined(boxStatus: BoxStatusType): boolean {
    switch (boxStatus) {
      case 'todo':
      case 'done':
      case 'waiting':
        return false;

      case 'na':
        return true;

      default:
        break;
    }

    return false;
  }

  checkZonaVincoloStatus() {
    return this.checkZonaVincolo ?? 'todo';
  }

  get checkZonaVincoloBoxDark() {
    return this.boxDark(this.checkZonaVincoloStatus());
  }

  get checkZonaVincoloBoxOutlined() {
    return this.boxOutlined(this.checkZonaVincoloStatus());
  }

  get checkZonaVincoloBoxColor() {
    return this.boxColor(this.checkZonaVincoloStatus());
  }

  get checkZonaVincoloLabel() {
    return this.boxText(this.checkZonaVincoloStatus());
  }

  autodichiarazioneClienteStatus() {
    return this.autodichiarazioneCliente ?? 'todo';
  }

  get autodichiarazioneClienteBoxDark() {
    return this.boxDark(this.autodichiarazioneClienteStatus());
  }

  get autodichiarazioneClienteBoxOutlined() {
    return this.boxOutlined(this.autodichiarazioneClienteStatus());
  }

  get autodichiarazioneClienteBoxColor() {
    return this.boxColor(this.autodichiarazioneClienteStatus());
  }

  get autodichiarazioneClienteLabel() {
    return this.boxText(this.autodichiarazioneClienteStatus());
  }

  get isVisible() {
    return this.hasPermission('taskcm.checkZonaVincolo.show')
      && this.hasPermission('taskcm.autodichiarazioneCliente.show');
  }

  get isEditable() {
    if (this.readonly) return false;

    return this.hasPermission('taskcm.checkZonaVincolo.edit')
      && this.hasPermission('taskcm.autodichiarazioneCliente.edit');
  }

  onEdit() {
    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    this.$emit('edit');
  }
}
